import { Link } from "react-router-dom";
import { type ReactNode } from "react";

interface CTAButtonProps {
  href: string;
  children: ReactNode;
  variant?: "primary" | "secondary" | "outline";
  className?: string;
  ariaLabel?: string;
}

export default function CTAButton({
  href,
  children,
  variant = "primary",
  className = "",
  ariaLabel,
}: CTAButtonProps) {
  const baseClasses =
    "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600";
  
  const variantClasses = {
    primary:
      "bg-blue-600 text-white hover:bg-blue-700 hover:-translate-y-0.5 shadow-lg hover:shadow-xl",
    secondary:
      "bg-gray-900 text-white hover:bg-gray-800 hover:-translate-y-0.5 shadow-lg hover:shadow-xl",
    outline:
      "border-2 border-blue-600 text-blue-600 hover:bg-blue-50 hover:border-blue-700",
  };

  return (
    <Link
      to={href}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  );
}



